export default {
  rebid_info: {},
  rebid_tariff: undefined,
};
